import React from 'react';

export const HighlightCommentContext = React.createContext(null);
HighlightCommentContext.displayName = 'HighlightCommentContext';
